import { render } from "./NavbarPage.vue?vue&type=template&id=28be97a6&scoped=true"
import script from "./NavbarPage.vue?vue&type=script&lang=js"
export * from "./NavbarPage.vue?vue&type=script&lang=js"

import "./NavbarPage.vue?vue&type=style&index=0&id=28be97a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28be97a6"]])

export default __exports__